import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/index";
const axios = require("axios");

const initialState = {
  loading: false,
  loadingMore: false,
  error: false,
  data: [],
  totalPage: 0,
  totalProducts: 0,
  singleProduct: {},
};

const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.products;
        state.totalPage = action.payload.totalPage;
        state.totalProducts = action.payload.totalProducts;
      })
      .addCase(getAllProducts.rejected, (state, action) => {
        state.loadingMore = false;
        state.error = action.payload;
      })
      .addCase(addMoreProducts.pending, (state) => {
        state.loadingMore = true;
      })
      .addCase(addMoreProducts.fulfilled, (state, action) => {
        state.loadingMore = false;
        state.data = [...state.data, ...action.payload.products];
        state.totalPage = action.payload.totalPage;
        state.totalProducts = action.payload.totalProducts;
      })
      .addCase(addMoreProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(createProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.data = [...state.data, action.payload];
      })
      .addCase(createProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const getAllProducts = createAsyncThunk(
  "reportsSlice/getAllProducts",
  async (data) => {
    try {
      const { url, method, headers } = api.getAllProducts(
        data.currentPage,
        data.searchQuery,
        data.selectedCollection,
        data.selectedSource,
        data.selectedTipology
      );
      const products = await axios({
        url,
        method,
        headers,
      });
      return products.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const addMoreProducts = createAsyncThunk(
  "reportsSlice/addMoreProducts",
  async (data) => {
    try {
      const { url, method, headers } = api.getAllProducts(
        data.currentPage,
        data.searchQuery,
        data.selectedCollection,
        data.selectedSource,
        data.selectedTipology
      );
      const products = await axios({
        url,
        method,
        headers,
      });
      return products.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const createProduct = createAsyncThunk(
  "reportsSlice/createProduct",
  async (productData) => {
    try {
      const { url, method, headers, data } = api.createProduct(productData);
      const product = await axios({
        url,
        method,
        headers,
        data,
      });
      return product.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const { actions } = productsSlice;
export default productsSlice.reducer;
